import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CHomeComponent } from './c-home.component';
import { WeeklyUpdatesModalComponent } from './weekly-updates-modal/weekly-updates-modal.component';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CHomeRoutingModule } from './c-home-routing.module';
import { ChSkeletonComponent } from '../shared/ch-skeleton/ch-skeleton.component';

@NgModule({
  declarations: [CHomeComponent, WeeklyUpdatesModalComponent],
  imports: [
    CommonModule,
    CustomDropdownModule,
    MaterialModule,
    CustomInputModule,
    FormsModule,
    ReactiveFormsModule,
    CHomeRoutingModule,
    ChSkeletonComponent
  ],
  exports: [CHomeComponent],
})
export class CHomeModule {}
